import React from 'react';
import Icon from '../../../components/AppIcon';

const ComingSoonDisplay = ({ settings }) => {
  return (
    <div className="w-full max-w-4xl mx-auto text-center space-y-8">
      {/* Logo */}
      <div className="flex items-center justify-center space-x-4 mb-8">
        <img 
          src="/assets/images/crc_logo_dia_logo_500-1759554868300.png" 
          alt="Crazy Rare Club Symbol" 
          className="w-16 h-16 object-contain"
          loading="eager"
        />
        <img 
          src="/assets/images/crc_logo_dia_text_500-1759554658424.png" 
          alt="Crazy Rare Club" 
          className="h-12 object-contain"
          loading="eager"
        />
      </div>

      {/* Main Content */}
      <div className="space-y-6">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-foreground leading-tight">
          {settings?.title || 'Coming Soon'}
        </h1>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          {settings?.description || 'We are working hard to bring you something amazing. Stay tuned!'}
        </p>
      </div>

      {/* Features Preview */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
        <div className="space-y-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto">
            <Icon name="Shield" size={24} className="text-primary" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">Secure Platform</h3>
          <p className="text-sm text-muted-foreground">
            Your collections are protected with enterprise-grade security
          </p>
        </div>
        
        <div className="space-y-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto">
            <Icon name="TrendingUp" size={24} className="text-primary" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">Market Insights</h3>
          <p className="text-sm text-muted-foreground">
            Real-time valuations and market analysis for your items
          </p>
        </div>
        
        <div className="space-y-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto">
            <Icon name="Users" size={24} className="text-primary" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">Community</h3>
          <p className="text-sm text-muted-foreground">
            Connect with fellow collectors and industry experts
          </p>
        </div>
      </div>

      {/* Newsletter Signup */}
      <div className="bg-card/30 backdrop-blur-sm rounded-lg border border-border p-8 mt-12">
        <h3 className="text-xl font-semibold text-foreground mb-3">
          Be the First to Know
        </h3>
        <p className="text-muted-foreground mb-6">
          Get notified when we launch and receive exclusive early access
        </p>
        
        <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input
            type="email"
            placeholder="Enter your email"
            className="flex-1 px-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          />
          <button
            type="submit"
            className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors whitespace-nowrap"
          >
            Notify Me
          </button>
        </form>
        
        <p className="text-xs text-muted-foreground mt-4">
          No spam, ever. Unsubscribe at any time.
        </p>
      </div>

      {/* Social Links */}
      <div className="flex items-center justify-center space-x-6 pt-8">
        <a 
          href="#" 
          className="w-10 h-10 bg-muted/30 rounded-full flex items-center justify-center hover:bg-primary/10 hover:text-primary transition-colors"
        >
          <Icon name="Twitter" size={20} />
        </a>
        <a 
          href="#" 
          className="w-10 h-10 bg-muted/30 rounded-full flex items-center justify-center hover:bg-primary/10 hover:text-primary transition-colors"
        >
          <Icon name="Facebook" size={20} />
        </a>
        <a 
          href="#" 
          className="w-10 h-10 bg-muted/30 rounded-full flex items-center justify-center hover:bg-primary/10 hover:text-primary transition-colors"
        >
          <Icon name="Instagram" size={20} />
        </a>
      </div>

      {/* Footer */}
      <div className="pt-8 border-t border-border/30">
        <p className="text-sm text-muted-foreground">
          © 2024 Crazy Rare Club. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default ComingSoonDisplay;